require('./contractPayrollLoanStepTwo.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const moment = require('moment');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');

//@components
const { ContractLoanPdfViewer } = require('../../contractLoanPdfViewer/contractLoanPdfViewer');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@utilities
const { formatCurrency, decimalsLength, formatAmount, getFormattedString, formatPercentage } = require('utilities/currencyHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { findPurposeById } = require('../payrollLoanPurposes');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { getLastNChars } = require('utilities/stringHelper');

//@constant
const { API_CENTER, API_ENTERPRISE_NUMBER, NOT_PRINT } = require('constants/index');
const { MULTIPLE_OPERATIONS, messages: { OPERATION_PAYROLL_GDPR, OPERATION_PAYROLL_NO_GDPR } } = require('constants/operationTypes');
const {
    amortizationTypes,
    payrollLoanCommon,
    contractEasyLoan: { PAYMENT_DAY_END_OF_MONTH },
    retailLoanProposition: { FORMALIZE_OPERATION },
    INE_DOCUMENT,
    CONTRACT_DOCUMENT,
} = require('../../../../loansConstants/index');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const { NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { OKMessage } = require('commonsComponents/OKMessage');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup')
const { RadioButton } = require('commonsComponents/radioButton')
//@components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const download = require('downloadjs');

class ContractPayrollLoanStepTwo extends React.Component {
    constructor(props) {
        super(props);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)
        this.handleAgreeCheckboxChange = this.handleAgreeCheckboxChange.bind(this);
        this.handleDownloadINEDocument = this.handleDownloadINEDocument.bind(this);
        this.handleDownloadPDFDocument = this.handleDownloadPDFDocument.bind(this);
        this.handleCheckboxDownloadEvents = this.handleCheckboxDownloadEvents.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
    }

    componentDidMount() {
        const { getProposition, getHiringDocuments, immFlagBasedFeatures } = this.props;
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)
        if (!newPayrollLoanFF) {

            getProposition()
                .then(() => {
                    if (!__CONTACT_CENTER__) {
                        getHiringDocuments();
                    }
                });
        }
    }

    componentWillUnmount() {
        const {
            resetDocumentsAndAgreeCheckBox,
            resetPrecontractualMail,
        } = this.props;

        resetDocumentsAndAgreeCheckBox();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    handleDownloadINEDocument(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.downloadINEDocument();
    }

    handleDownloadPDFDocument(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.downloadLoanContractDocument();
    }

    buildSignaturePattern() {
        const { immPayrollLoan, immAccounts, immFlagBasedFeatures } = this.props;
        const proposition = immPayrollLoan.get('proposition');
        const agreeCheckbox = immPayrollLoan.get('agree');

        const ammount = immPayrollLoan.get('selectedAmount');
        const currency = immPayrollLoan.get('currency');

        const selectedAccount = immPayrollLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountProduct = immAccount.get('newProduct');
        const accountContract = immAccount.get('newContractNumber');

        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + accountProduct + accountContract;
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)

        const propositionYear = proposition.get('propositionYear');
        const propositionNumber = proposition.get('propositionNumber');
        const optional1 = API_ENTERPRISE_NUMBER + API_CENTER + propositionYear + propositionNumber;
        const serviceCode = FORMALIZE_OPERATION;
        const operationProcessId = immPayrollLoan.get('payrollInitOperationProcessId');
        const operationParams = [
            {
                serviceCode,
                ammount,
                currency,
                optional1,
                originAccount,
            }];
        return proposition.get('success') && operationProcessId ? (
            <GDPRSignaturePattern
                operationType={MULTIPLE_OPERATIONS}
                operationParams={operationParams}
                multiOTPGDPRMessageCode={OPERATION_PAYROLL_GDPR}
                multiOTPMessageCode={OPERATION_PAYROLL_NO_GDPR}
                isOverDraft={__CONTACT_CENTER__ && isPrintOfficeMode() ? null : newPayrollLoanFF ? true : false}
                isEasyLoanTypeAB={__CONTACT_CENTER__ && isPrintOfficeMode()}
                newOperationProcessId={operationProcessId}
            />
        ) : null;
    }

    handleAgreeCheckboxChange() {
        this.props.setAgree();
    }

    handleCheckboxDownloadEvents(event, docType) {
        if (docType === INE_DOCUMENT) {
            this.handleDownloadINEDocument(event);
        } else {
            this.handleDownloadPDFDocument(event);
        }
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={event => this.handleCheckboxDownloadEvents(event, docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }

    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`contractPayrollLoanAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('contractPayrollLoanIneDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('contractPayrollLoanContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }
    handleOpenPdfNewTab() {
        const { immPayrollLoan } = this.props;
        const document = immPayrollLoan.get('filePayrollLoanINEDocument');
        if (document) {
            openBase64pdfInPrintWindow(document, true);
        }
    }
    buildPdfLink() {

        return (
            <>
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={translationContractLoanPdfViewerINE.SUBTITLE_CONFIRM_PAGE} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed contract-payrollLoan-readed">
                        <button className="link--red option-link" onClick={() => this.handleOpenPdfNewTab()}>
                            <FormattedText value={translationContractLoanPdfViewerINE.PERSONAL_LOAN_TEXT_CONFIRM_PAGE} />
                        </button>

                        <span><i className="signature-pattern-code-input__icon icon icon-check" />
                            <FormattedText className="signature-text" value={translationContractLoanPdfViewerINE.LEGAL_INFO_READ_BUTTON} />
                        </span>
                    </div>
                    {__CONTACT_CENTER__ ? null :
                        <>
                            <br />
                            <div className="contract-easy-loan-step-four__informative-text">
                                <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_SUBTITLE_STEP4} />
                            </div>
                        </>
                    }
                    {__CONTACT_CENTER__ && isPrintOfficeMode() &&
                        <>
                            <br />
                            <div className="contract-easy-loan-step-four__informative-text">
                                <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_SUBTITLE_STEP4} />
                            </div>
                            {this.builBlock()}
                        </>
                    }
                </div>

            </>
        )
    }
    handleOnDownloadDocument() {
        const { immPayrollLoan } = this.props;
        const document = immPayrollLoan.get('filePayrollLoanPolicyDocument');
        download(document, CONTRACT_DOCUMENT, 'application/pdf');

    }
    buildViewer() {
        const {
            immPayrollLoan,
            onDownloadDocument,
            onPrintDocument,
            getHiringDocuments,
            immFlagBasedFeatures
        } = this.props;
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)
        const documents = immPayrollLoan.get('documents');
        const documentsPolicy = immPayrollLoan.get('filePayrollLoanPolicyDocument')
        const isFetchingPrintDocuments = immPayrollLoan.get('isFetchingPrintDocuments');
        const agreeCheckbox = immPayrollLoan.get('agree');
        const validate = immPayrollLoan.get('agreeError');
        const errorDocumentZip = immPayrollLoan.get('errorDssocumentZip');
        const loadingDownload = immPayrollLoan.get('isFetchingZip');
        const poeditorPrefix = 'contractPayrollLoanStepTwo';
        const isLoading = immPayrollLoan.get('isFetchingDocuments');
        const errorLoading = immPayrollLoan.get('errorDocuments');
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title_legal_component`);
        const checkboxLabel = this.buildCheckboxLabel(poeditorPrefix);
        const pdfLink = newPayrollLoanFF ? this.buildPdfLink() : null
        if (newPayrollLoanFF) {
            return (<>
                {pdfLink}
                {__CONTACT_CENTER__ && !isPrintOfficeMode() ? null :
                    <ContractLoanPdfViewer
                        agreeCheckbox={agreeCheckbox}
                        checkboxLabel={checkboxLabel}
                        document={documentsPolicy}
                        downloadError={errorDocumentZip}
                        errorLoading={errorLoading}
                        getDocuments={getHiringDocuments}
                        hasSignaturePattern
                        isCallingDownloadService={isFetchingPrintDocuments}
                        isLoading={isLoading}
                        loadingDownload={loadingDownload}
                        onAgreeCheckbox={this.handleAgreeCheckboxChange}
                        onDownload={newPayrollLoanFF ? () => this.handleOnDownloadDocument() : onDownloadDocument}
                        onPrint={onPrintDocument}
                        title={title}
                        validate={validate}
                        showOfficeCheckBox={isPrintOfficeMode()}
                        checkboxFlag={false}
                        checkboxShow={false}

                    />
                }
            </>
            );
        } else {
            return (
                <ContractLoanPdfViewer
                    agreeCheckbox={agreeCheckbox}
                    checkboxLabel={checkboxLabel}
                    document={documents}
                    downloadError={errorDocumentZip}
                    errorLoading={errorLoading}
                    getDocuments={getHiringDocuments}
                    hasSignaturePattern
                    isCallingDownloadService={isFetchingPrintDocuments}
                    isLoading={isLoading}
                    loadingDownload={loadingDownload}
                    onAgreeCheckbox={this.handleAgreeCheckboxChange}
                    onDownload={onDownloadDocument}
                    onPrint={onPrintDocument}
                    title={title}
                    validate={validate}
                />
            );
        }

    }
    handleDocumentReaded() {
        const { checkReadDocument } = this.props;
        checkReadDocument()
    }
    handleOnPrintDocument() {
        const { immPayrollLoan, checkCheckedDocument } = this.props;
        const document = immPayrollLoan.get('filePayrollLoanPolicyDocument');
        if (document) {
            openBase64pdfInPrintWindow(document);
        }
        if (isPrintOfficeMode()) {
            const agreeIneCheckbox = immPayrollLoan.get('agreeIneCheckbox')
            checkCheckedDocument(agreeIneCheckbox)
        }
    }

    buildCheckboxElement() {
        const { immPayrollLoan, preContractualMail } = this.props;
        const agreeCheckbox = immPayrollLoan.get('agree');
        const validate = immPayrollLoan.get('agreeError');
        const errorMessage = formatText('contractPayrollLoanStepTwo-checkboxErrorMessage');
        const mailSent = preContractualMail.get('mailSent');

        const checkboxLabel = (
            <div>
                <FormattedText value="contractPayrollLoanStepTwo-checkboxTextPart1" />
                <OKButton
                    autoHeight
                    modifier="link-emphasize"
                    onClick={this.handleDownloadINEDocument}
                >
                    <FormattedText value="contractPayrollLoanStepTwo-ine" />
                </OKButton>
                <FormattedText value="contractPayrollLoanStepTwo-checkboxTextPart2" />
                <OKButton
                    autoHeight
                    modifier="link-emphasize"
                    onClick={this.handleDownloadPDFDocument}
                >
                    <FormattedText value="contractPayrollLoanStepTwo-payrollLoanPolicy" />
                </OKButton>
                <FormattedText value="contractPayrollLoanStepTwo-checkboxTextPart3" />
            </div>
        );

        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check" hasCheckbox>
                <OKCheckbox
                    idName="contract-payroll-loan-read-checkbox"
                    label={checkboxLabel}
                    value={agreeCheckbox}
                    onChange={this.handleAgreeCheckboxChange}
                    errorState={validate}
                    errorMessage={errorMessage}
                    disabled={!mailSent}
                />
            </BlockInfo>
        );
    }

    buildSummary() {
        const { immPayrollLoan, immAccounts, immFlagBasedFeatures } = this.props;
        const rawAmount = immPayrollLoan.get('selectedAmount');
        const rawArrangementFee = immPayrollLoan.get('arrangementFee');
        const rawCurrency = immPayrollLoan.get('currency');
        const selectedAccount = immPayrollLoan.get('selectedAccount');

        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const currency = formatCurrency(rawCurrency);
        const decimalsLengthLoanImport = decimalsLength(rawAmount);
        const decimalsArragementFee = decimalsLength(rawArrangementFee);
        const arrangementFee = formatAmount(rawArrangementFee, decimalsArragementFee);
        const accountAlias = immAccount.get('alias');
        const accountIban = getLastNChars(immAccount.get('iban'));
        let footerList = [];

        if (__CONTACT_CENTER__ && !isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)) {
            footerList = [
                {
                    id: 'TIN',
                    text: formatText('contractPayrollLoanSummary-TIN'),
                    value: formatPercentage(immPayrollLoan.get('tin')),
                    typeStyle: 'medium'

                },
                {
                    id: 'TAE',
                    text: formatText('contractPayrollLoanSummary-TAE'),
                    value: formatPercentage(immPayrollLoan.get('tae')),
                    typeStyle: 'medium'

                },
                {
                    id: 'associatedAccount',
                    text: formatText('contractPayrollLoanSummary-associatedAccount'),
                    value: `${accountAlias} ${accountIban}`,
                    typeStyle: 'large'

                }]
        }
        const summary = [
            {
                id: 'loanAmount',
                value: getFormattedString({
                    amount: rawAmount,
                    currency,
                    decimalsLength: decimalsLengthLoanImport
                }),
                typeStyle: 'medium'
            },
            {
                id: 'term',
                value: formatText('contractPayrollLoanStepTwo-termMonths', [immPayrollLoan.get('selectedTerm')]),
                typeStyle: 'small'
            },
            {
                id: 'monthlyInstallment',
                value: getFormattedString(immPayrollLoan.get('installment')),
                typeStyle: 'medium'
            },
            {
                id: 'arrangementFee',
                additionalLabel: (<sup>1</sup>),
                value: `${arrangementFee} ${currency}`,
                extra: immPayrollLoan.get('arrangementPercentage'),
                typeStyle: 'large'
            }
        ].concat(footerList);

        const elements = summary.map((item, index) => {
            return (
                <li className={`contract-payroll-loan-step-two__list-element contract-payroll-loan-step-two__list-element--${item.typeStyle}`}
                    key={`element-${index}`}>
                    <FormattedText
                        value={`contractPayrollLoanStepTwo-${item.id}`}
                        injectedStrings={[item.extra]}
                    />
                    {item.additionalLabel ? item.additionalLabel : null}
                    <p className="contract-payroll-loan-step-two__list-element-value">
                        {item.value}
                    </p>
                </li>
            );
        });

        return (
            <ul className="contract-payroll-loan-step-two__list">
                {elements}
            </ul>
        );
    }

    buildPreContractualMailInfo() {
        const {
            immAccounts,
            immProfile,
            immPayrollLoan,
            isDragoFeature,
            requestProfile,
            preContractualMail,
            sendMail,
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const refreshEmailError = immProfile.get('error');
        const indCapson = immPayrollLoan.get('indCapson');

        const selectedAccount = immPayrollLoan.get('selectedAccount');
        const endOfMonth = immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
        const financedCommission = indCapson === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;

        let selectedPurpose = findPurposeById(immPayrollLoan.get('selectedPurpose'));
        if (isDragoFeature) {
            const finalPurpose = immPayrollLoan.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immPayrollLoan.get('selectedPurposeDrago'));
            selectedPurpose = finalPurpose.get('text');
        }
        const purposeText = selectedPurpose ? formatText(selectedPurpose.text) : '';
        const immProposition = immPayrollLoan.get('proposition');

        const sendMailParams = {
            amount: formatAmount(immPayrollLoan.get('selectedAmount')),
            calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee')),
            capitalizedOpeningCommissionIndicator: indCapson,
            clientAccountCode: immAccounts.getIn(['byId', selectedAccount, 'iban']),
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth,
            financedCommission,
            firstTime: true,
            loanPurpose: purposeText,
            productDuration: immPayrollLoan.get('selectedTerm').toString(),
            productType: payrollLoanCommon.PRODUCT_TYPE,
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber', '').toString(),
            tae: formatAmount(immPayrollLoan.get('tae')),
            tin: formatAmount(immPayrollLoan.get('tin')),
            workflowSegmentation: true,
            year: immProposition.get('propositionYear'),
        };

        return (
            <PreContractualMailInfo
                email={clientEmail}
                preContractualMail={preContractualMail}
                profileError={refreshEmailError}
                requestProfile={requestProfile}
                sendEmail={sendMail}
                sendMailParams={sendMailParams}
                showLegalText={false}
            />
        );
    }
    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton } = this.props

        checkRadioButton(value === 'yes' ? true : false)
        printedAndSignedRadioChanged(value)
        enableButtonOffice();
    }
    buildQuestion(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);
        const keyName = `<b>${name}</b>`;

        return (<FormattedText value={text} injectedStrings={[keyName]} />);
    }
    buildNameBlock(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);

        return (<BlockInfo><FormattedText value={text} injectedStrings={[name]} /></BlockInfo>);
    }
    builBlock() {

        return (<BlockInfo><FormattedText value={'contractPayrollLoanStepTwo-contractPayrollLoanBlockOfficeDescription'} injectedStrings={['contractPayrollLoanBlockOfficeTitle']} /></BlockInfo>);
    }
    buildViewerOffice() {
        const {
            immPayrollLoan,
            getHiringDocuments,
            immFlagBasedFeatures
        } = this.props;
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)
        const documentsPolicy = immPayrollLoan.get('filePayrollLoanPolicyDocument')
        const poeditorPrefix = 'contractPayrollLoanStepTwo';
        const errorLoading = immPayrollLoan.get('errorDocuments');
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_new_title_legal_component`);
        const pdfLink = newPayrollLoanFF ? this.buildPdfLink() : null
        const DEFAULT_VIEWER_HEIGHT = 320;

        if (newPayrollLoanFF) {
            return (<>
                {pdfLink}
                <div className="contract-loan-pdf-viewer__document">
                    <OKPdfViewer
                        onDownload={() => this.handleOnDownloadDocument()}
                        onPrint={this.handleOnPrintDocument}
                        pdfFile={documentsPolicy}
                        title={title}
                        infiniteScroll={false}
                        failedLoadingPdf={errorLoading}
                        displayScrollButton
                        errorComponent={() => {
                            return <ContractLoanPdfViewerError getDocuments={getHiringDocuments} />
                        }}
                        viewerHeight={DEFAULT_VIEWER_HEIGHT}
                        onDocumentReaded={this.handleDocumentReaded}
                    />
                </div>
            </>
            );
        }
    }
    render() {
        const {
            immFlagBasedFeatures,
            immPayrollLoan,
            immPrinter
        } = this.props;
        const summary = this.buildSummary();
        const signature = this.buildSignaturePattern();
        const precontractualMailInfo = __CONTACT_CENTER__ ? this.buildPreContractualMailInfo() : null;
        const checkboxElement = __CONTACT_CENTER__ ? this.buildCheckboxElement() : null;
        const title = formatText('contractPayrollLoanStepTwo-title');
        const primaryMessage = formatText('contractPayrollLoanStepTwo-primaryMessage');
        const pdfViewer = !__CONTACT_CENTER__ ? this.buildViewer() : null;
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES)
        const confirmationQuestion = this.buildQuestion('confirmationScript-promptMsg')
        const requestPurchaseConfirmation = this.buildNameBlock('contractEasyLoanStepThree-blockInfoSubTitle')
        const printDocument = immPayrollLoan.get('printDocument');
        const documentsPrintedAndSigned = immPrinter.get('documentsPrintedAndSigned')
        return (
            <>
                {newPayrollLoanFF ?
                    <>

                        {!__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                            <section>
                                <h2 className="contract-payroll-loan-step-two__title">
                                    {title}
                                </h2>
                                <p className="contract-payroll-loan-step-two__message">
                                    {primaryMessage}
                                </p>
                                {summary}
                                <div>
                                    <OKConsents placementId="contractPayrollLoan" />
                                </div>
                                {precontractualMailInfo}
                                {checkboxElement}
                                <div className="contract-payroll-loan-step-two__separator"></div>
                                {pdfViewer}
                                {signature}
                            </section>
                        }
                        {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                            <section>
                                <h2 className="contract-payroll-loan-step-two__title">
                                    {title}
                                </h2>
                                <p className="contract-payroll-loan-step-two__message">
                                    {primaryMessage}
                                </p>
                                {requestPurchaseConfirmation}

                                {summary}
                                <div className="contract-easy-loan-step-four__informative-text">
                                    <OKMessage type="informative">
                                        <FormattedText value="contractEasyLoanStepThree-informativeTitle" className="contract-easy-loan-step-four__informativeTitle" /> <br />
                                        <FormattedText value="contractEasyLoanStepThree-informativeSubTitle" />
                                    </OKMessage>
                                </div>

                                <div>
                                    <OKConsents placementId="contractPayrollLoan" />
                                </div>

                                <div className="contract-payroll-loan-step-two__separator"></div>
                                {this.buildViewer()}
                                <div className="contract-easy-loan-step-four__confirmation-question">{confirmationQuestion}</div>

                                {signature}
                            </section>
                        }
                        {__CONTACT_CENTER__ && isPrintOfficeMode() &&
                            <section>
                                <h2 className="contract-payroll-loan-step-two__title">
                                    {title}
                                </h2>
                                <p className="contract-payroll-loan-step-two__message">
                                    {primaryMessage}
                                </p>
                                {summary}
                                <div>
                                    <OKConsents placementId="contractPayrollLoan" />
                                </div>
                                <div className="contract-payroll-loan-step-two__separator"></div>
                                {this.buildViewerOffice()}

                                <div className='contract-payroll-loan-step-two__radio-group'>

                                    {printDocument && signature}
                                </div>
                                <div className="no-print-out">
                                    {documentsPrintedAndSigned === NOT_PRINT && (
                                        <div className='contract-payroll-loan-step-two'>
                                            <p className='contract-payroll-loan-step-two__radioButtonNotSelected' >{formatText(`hireCardOpenCreditStepINE-radioButtonNotSelected`)}</p>
                                        </div>

                                    )}
                                </div>
                            </section>
                        }
                    </>
                    :
                    <section>
                        <h2 className="contract-payroll-loan-step-two__title">
                            {title}
                        </h2>
                        <p className="contract-payroll-loan-step-two__message">
                            {primaryMessage}
                        </p>
                        {summary}
                        <div>
                            <OKConsents placementId="contractPayrollLoan" />
                        </div>
                        {precontractualMailInfo}
                        {checkboxElement}
                        <div className="contract-payroll-loan-step-two__separator"></div>
                        {pdfViewer}
                        {signature}
                    </section>
                }
            </>

        );
    }
}

ContractPayrollLoanStepTwo.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadLoanContractDocument: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immPayrollLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired
};

module.exports = ContractPayrollLoanStepTwo;
